import { Record } from 'immutable';
const ArticleFeedbackReportRecord = Record({
  error: undefined,
  isRequesting: false,
  countHelpful: undefined,
  countTotal: undefined,
  countUnhelpful: undefined,
  lastLoaded: undefined
});
export default ArticleFeedbackReportRecord;